import styled from "styled-components";
import LeftMenu from "./LeftMenu";

const MainContent = styled.main`
    width: 100%;
    height: 100%;
    min-height: 100vh;
    background-color: #4E4E4E;
    background-size: 40px 40px;
    background-image:
    linear-gradient(to right, #3E3E3E 1px, transparent 1px),
    linear-gradient(to bottom, #3E3E3E 1px, transparent 1px);

`
const SubpageLayoutDiv = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;

    @media (max-width: 800px) {
        flex-direction: column;
    }
`

export default function SubpageLayout(props: { children: React.ReactNode }) {
    return (
        <SubpageLayoutDiv>
            <LeftMenu></LeftMenu>
            <MainContent>
                {props.children}
            </MainContent>
        </SubpageLayoutDiv>
    );
}
